import ColorFunc from 'color';
import styled from 'styled-components';

import { Border, Color, Spacing, FontFamily, FontSize, FontWeight } from '~/src/atomic/obj.constants';
import { highlightStyle } from '~/src/atomic/obj.mixin';

import { FlashMessageProps } from './flash-message.component';

const flashMessageTypes = {
  warning: Color.Warning,
  success: Color.Success,
  info: Color.Accessory,
  alert: Color.Alert,
};

export const FlashMessageContentStyled = styled.div`
  flex-grow: 1;
  margin: 0 ${Spacing.Medium};
`;

export const FlashMessageCloseStyled = styled.div<FlashMessageProps>`
  ${highlightStyle}
`;

export const FlashMessageStyled = styled.div<FlashMessageProps>`
  background-color: ${(props) => ColorFunc(flashMessageTypes[props.type]).lighten(4).string()};
  border-radius: ${Border.Radius};
  display: flex;
  padding: ${Spacing.Medium};
  font-family: ${FontFamily.Primary};
  font-weight: ${FontWeight.Normal};
  font-size: ${FontSize.Small};
  transition: opacity 0.3s ease-in-out;

  svg {
    color: ${(props) => flashMessageTypes[props.type]};
  }
`;

export const FlashMessageIconStyled = styled.div`
  margin-top: ${Spacing.XSmall};
`;
